import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { companyInformation, developerInformation } from '../../companyinformation';
import { DOCUMENT } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class SeoService {

  constructor(
    private meta: Meta,
    private titleService: Title,
    @Inject(DOCUMENT) private document: Document
  ) { }

  generateTags(tags: {
    title: string,
    description?: string,
    image?: string,
    route: string,
    author?: string,
    type?: 'article' | 'profile' | 'website'
  }) {
    const title = `${tags.title} - ${companyInformation.name}`;
    const description = tags.description ?? companyInformation.byline;
    const image = tags.image ?? '/assets/imgs/logo.webp';
    const domain = this.document.location.hostname;
    /* set title */
    this.titleService.setTitle(title);

    /* set twitter meta tags */
    this.meta.updateTag({ name: 'twitter:card', content: 'summary' });
    this.meta.updateTag({ name: 'twitter:site', content: companyInformation.socials.twitter });
    this.meta.updateTag({ name: 'twitter:title', content: title });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: image });

    /* set open graph meta tags */
    this.meta.updateTag({ name: 'author', content: tags.author ?? developerInformation.name });
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ property: 'og:type', content: tags.type ?? 'website' });
    this.meta.updateTag({ property: 'og:site_name', content: companyInformation.name });
    this.meta.updateTag({ property: 'og:title', content: title });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:image', content: image });
    this.meta.updateTag({ property: 'og:url', content: domain + tags.route });
  }
}
